import { MovementContactScopeFilter } from './filters/movementContactScopeFilter';
import { MovementSharedListFilter } from './filters/movementSharedListFilter';
import { MovementCompanyFilter } from './filters/movementCompanyFilter';
import { MovementTypeFilter } from './filters/movementTypeFilter';
import { MovementDateFilter } from './filters/movementDateFilter';

export const createMovementsFilterGroups = ({ filters, setFilters }) => [
  {
    id: 'network',
    title: 'Network',
    show: true,
    filters: [
      {
        id: 'contactScope',
        Component: MovementContactScopeFilter,
        props: {
          value: filters.contactScope,
          setFilters,
        },
        show: true,
      },
      {
        id: 'sharedListIds',
        Component: MovementSharedListFilter,
        props: {
          value: filters.sharedListIds,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'company',
    title: 'Company',
    show: true,
    filters: [
      {
        id: 'companies',
        Component: MovementCompanyFilter,
        props: {
          value: filters.companies,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'movement',
    title: 'Movement',
    show: true,
    filters: [
      {
        id: 'movementType',
        Component: MovementTypeFilter,
        props: {
          value: filters.movementType,
          setFilters,
        },
        show: true,
      },
      {
        id: 'dateFrom',
        Component: MovementDateFilter,
        props: {
          dateFrom: filters.dateFrom,
          dateTo: filters.dateTo,
          setFilters,
        },
        additionalCountKeys: ['dateTo'],
        show: true,
      },
    ],
  },
];
